import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { validateState, getValue, VALIDATION_EMPTY_FIELD } from '../../hooks/useForm/validate';

export const usePassengerInfoField = (
    passengerInfo,
    recordId,
    name,
    defaultValue,
    editPassengerInfo,
    onChangeValue,
    required,
    validator
) => {
    const { t: translate } = useTranslation();
    const [errorText, changeError] = useState(required && !defaultValue ? translate('errors.validate.fieldIsRequired') : '');
    const [field, changeField] = useState({
        name: '',
        title: '',
        type: 'number',
        validator: { type: 'smallint', min: 0 },
    });

    useEffect(() => {
        changeField((prevState) => ({
            ...prevState,
            name,
            title: name,
            validator: { ...(validator || field.validator), isRequired: required },
        }));
    }, [validator, required]);

    const handleInputFocus = useCallback(() => {
        if (errorText) {
            changeError('');
        }
    }, []);

    const handleInfoChange = useCallback(
        (evt) => {
            const { validator, isRequired = false } = field;
            const fieldValue = evt.currentTarget.value === '' ? undefined : getValue(validator, evt.currentTarget.value);
            const validateRes = validateState(validator, fieldValue, isRequired, translate);

            if (validateRes !== null && validateRes.errorText !== translate(VALIDATION_EMPTY_FIELD)) {
                return changeError(validateRes.errorText);
            }

            if (editPassengerInfo) {
                editPassengerInfo(recordId, passengerInfo.cls, passengerInfo.type, evt.target.name, fieldValue);
            }
            if (onChangeValue) {
                onChangeValue(fieldValue);
            }
        },
        [passengerInfo, editPassengerInfo, translate]
    );

    return {
        errorText,
        handleInputFocus,
        handleInfoChange,
    };
};
